import React from 'react';
import { Client as URQLClient } from 'urql';

import { getProductivityClient } from './index';

const ProductivityClientContext = React.createContext<URQLClient | null>(null);

export const useProductivityClient = (): URQLClient => {
  const client = React.useContext(ProductivityClientContext);

  if (!client) {
    throw new Error('useProductivityClient must be used within ProductivityClientProvider');
  }

  return client;
};

const ProductivityClientProvider: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const urqlClient = React.useMemo<URQLClient>(() => getProductivityClient({}), []);

  return (
    <ProductivityClientContext.Provider value={urqlClient}>
      {children}
    </ProductivityClientContext.Provider>
  );
};

export default ProductivityClientProvider;
